import Address from '@/classes/addresses/Address'
import Transactions from '@/classes/transactions/Transactions'
import SportingStatistics from '@/classes/statistics/SportingStatistics'
import { capitalize as _capitalize } from 'lodash'

export default class User {
  constructor ({ id = null, firstname = null, lastname = null, email = null, gender = null, avatar = null, language = null, birthday = null, role = null, is_super_admin = false, phone_number = null, address = {}, notifications = {}, transactions, integrations = {}, sporting_statistics = {}, is_verified = false, created_at = null, omniauth_ids = {}, current_password = null, password = null, password_confirmation = null } = {}) {
    this.id = id
    this.firstname = firstname
    this.lastname = lastname
    this.email = email
    this.gender = gender
    this.avatar = avatar
    this.language = language
    this.birthday = birthday
    this.role = role
    this.is_super_admin = is_super_admin
    this.phone_number = phone_number
    this.address = new Address(address)
    this.notifications = notifications
    this.transactions = new Transactions(transactions)
    this.integrations = integrations
    this.sporting_statistics = new SportingStatistics(sporting_statistics)
    this.is_verified = is_verified
    this.created_at = created_at
    this.omniauth_ids = omniauth_ids
    this.current_password = current_password
    this.password = password
    this.password_confirmation = password_confirmation
  }

  get fullname () {
    return [this.firstname, this.lastname].join(' ')
  }

  get public_name () {
    return [this.firstname, this.lastname ? this.lastname.charAt(0) + '.' : null].filter(name => name).join(' ')
  }

  get is_koalect () {
    return this.role === 'koalect'
  }

  get is_admin () {
    return this.role === 'admin'
  }

  get has_omniauth_ids () {
    return !!Object.keys(this.omniauth_ids).length
  }

  get to_mixpanel () {
    return {
      '$user_id': this.id,
      '$avatar': this.avatar.url,
      '$email': this.email,
      '$phone': this.phone_number,
      '$first_name': this.firstname,
      '$last_name': this.lastname,
      '$language': this.language,
      '$role': _capitalize(this.role).replace('_', ' '),
      '$birthday': this.birthday
    }
  }
}